export default __webpack_public_path__ + "static/media/mari_l.539db118.jpg";